import { defaultTo } from 'lodash';
import {
  IModel,
  Model,
  ModelRecord,
  SalesSubCategoryModel,
} from '@common/models';

export interface ISalesCategoryModel extends IModel {
  salesCategoryId: number;
  name: string;
  displayName: string;
  sortOrder: number;
  salesSubCategories: SalesSubCategoryModel[];
}

export class SalesCategoryModel
  extends Model
  implements ModelRecord<ISalesCategoryModel>
{
  salesCategoryId: number;
  name: string;
  displayName: string;
  sortOrder: number;
  salesSubCategories: SalesSubCategoryModel[];

  constructor(params?: ISalesCategoryModel) {
    super(params);
    this.salesCategoryId = defaultTo(params?.salesCategoryId, 0);
    this.name = defaultTo(params?.name, '');
    this.displayName = defaultTo(params?.displayName, '');
    this.sortOrder = defaultTo(params?.sortOrder, 999);
    this.salesSubCategories = defaultTo(
      params?.salesSubCategories,
      [] as Array<SalesSubCategoryModel>,
    ).map((s) => new SalesSubCategoryModel(s));
  }
}
